<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      Pembayaran Beasiswa: {{ mahasiswa.name }}
    </h1>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4 text-left whitespace-normal break-words">
            Tanggal Pembayaran
          </th>
          <th class="px-6 pt-6 pb-4 text-left">
            Bank Mahasiswa
          </th>
          <th class="px-6 pt-6 pb-4 text-left whitespace-normal break-words">
            No Rekening Mahasiswa
          </th>
          <th class="px-6 pt-6 pb-4 text-left whitespace-normal break-words">
            Tahun Ajaran
          </th>
          <th class="px-6 pt-6 pb-4 text-left">
            Semester
          </th>
          <th class="px-6 pt-6 pb-4 text-left whitespace-normal break-words">
            Status Pembayaran
          </th>
          <th class="px-6 pt-6 pb-4 text-right whitespace-normal break-words">
            Nominal Pembayaran
          </th>
          <th class="px-6 pt-6 pb-4 text-left whitespace-normal break-words">
            Bukti Pembayaran
          </th>
        </tr>
        <tr
          v-for="row in payments.data"
          :key="row.id"
          class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t px-6 py-4 text-left">
            {{ row.payment_date }}
          </td>
          <td class="border-t px-6 py-4 text-left">
            {{ row.scholarship_bank }}
          </td>
          <td class="border-t px-6 py-4 text-left">
            {{ row.scholarship_bank_acc_number }}
          </td>
          <td class="border-t px-6 py-4 text-left">
            {{ row.school_year }}
          </td>
          <td class="border-t px-6 py-4 text-left">
            {{ row.school_semester }}
          </td>
          <td class="border-t px-6 py-4 text-left">
            {{ row.payment_status }}
          </td>
          <td class="border-t px-6 py-4 text-right">
            {{ formatNumber(row.payment_amount) }}
          </td>
          <td class="border-t px-6 py-4 text-left">
            <button
              v-if="row.payment_file"
              class="font-bold text-indigo-600 underline"
              @click.prevent="showModal(row.payment_file)">
              Lihat
            </button>
          </td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="payments.links" />
    <modal :is-modal-show="isModalVisible" @close="closeModal">
      <template slot="header">
        Gambar scan Bukti Pembayaran
      </template>
      <template slot="body">
        <div class="flex justify-center">
          <blob-image :src="imgUrl" />
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import Modal from '@/Shared/Modal'
import BlobImage from '@/Shared/BlobImage'

export default {
    metaInfo: { title: 'KRS' },

    components: {
        Pagination,
        Modal,
        BlobImage,
    },

    layout: Layout,

    props: {
        mahasiswa: Object,
        payments: Object,
    },

    data () {
        return {
            imgUrl: null,
            isModalVisible: false,
        }
    },

    methods: {
        is_verified_icon (val) {
            return val ? 'fas fa-check-circle' : 'fas fa-times-circle'
        },
        formatNumber (num) {
            return num ? num.toLocaleString('id-ID') : '0'
        },
        showModal (filename) {
            this.imgUrl = `/preview/${filename}`
            this.isModalVisible = true
        },
        closeModal () {
            this.isModalVisible = false
        },
    },
}
</script>

